import { render, staticRenderFns } from "./RegistrationConfirmation.vue?vue&type=template&id=7cc28138&scoped=true&"
import script from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirmation.vue?vue&type=style&index=0&id=7cc28138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc28138",
  null
  
)

export default component.exports